import FadeIn from "react-fade-in";
import Modal from "../../../atom/modal";
import ThemedButton from "../../../atom/ThemedButton/themedButton";
import ToggleButton from "../../../atom/toggleButton";
import {
  getToken,
  updateExtensionStatus,
  updatePin,
} from "../../../services/api";
import Notification from "../../../atom/Notification";
import { useParams } from "react-router-dom";
import { useState } from "react";
import ComponentMap from "../../../atom/componentmap";

function EditTenantExtensionModal(props: any) {
  const id = getToken();
  const { setEditExtensionModal, setKey, rowData } = props;
  const [localRowData, setLocalRowData] = useState<any>(rowData);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [resetPinLoader, setResetPinLoader] = useState<boolean>(false);
  const [resetPinModal, setResetPinModal] = useState<boolean>(false);

  const displayData = [
    { key: "extension", label: "Extension" },
    { key: "first_name", label: "First Name" },
    { key: "last_name", label: "Last Name" },
  ];

  const toggleOptions = [
    { key: "is_monitorable", label: "Supervisor Tools" },
    { key: "is_recordable", label: "Record" },
    // { key: "time_zone_restriction", label: "Time Zone Restriction" },
    // { key: "speech_analytics_enabled", label: "Speech Analytics" },

    // { key: "is_sms_enabled", label: "SMS" },
  ];

  const [pinData, setPinData] = useState([
    {
      title: "New PIN",
      name: "new_pin",
      type: "number",
      // regEx: regEx.number,
      value: "",
      minLength: 4,
      maxLength: 10,
      hidden: false,
      layout: 6,
    },
    // {
    //   title: "Confirm New PIN",
    //   name: "confirm_pin",
    //   type: "password",
    //   regEx: regEx.number,
    //   value: "",
    //   minLength: 4,
    //   maxLength: 10,
    //   hidden: false,
    //   layout: 6,
    // },
  ]);

  const handleSubmit = () => {
    setButtonLoader(true);
    const payload = {
      is_monitorable: localRowData?.is_monitorable,
      is_recordable: localRowData?.is_recordable,
      // time_zone_restriction: localRowData?.time_zone_restriction,
      // is_sms_enabled: localRowData?.is_sms_enabled,
      // speech_analytics_enabled: localRowData?.speech_analytics_enabled,
    };
    updateExtensionStatus(payload, id, rowData?.uuid).then((result: any) => {
      if (!result?.success) {
        setButtonLoader(false);
        let msg = result?.message;
        Notification(
          "Failed",
          msg?.charAt(0).toUpperCase() + msg.slice(1),
          "danger",
        );
      } else {
        setButtonLoader(false);
        setEditExtensionModal(false);
        setKey((prev: number) => prev + 1);
        Notification("Success", "Extension updated successfully", "success");
      }
    });
  };

  const handleChecked = (data: any) => {
    setLocalRowData((prev: any) => ({
      ...prev,
      [data.key]: !prev[data.key],
    }));
  };

  const handleResetPinClick = () => {
    setResetPinModal(!resetPinModal);
  };

  const handleUpdatePin = (pin: any) => {
    setResetPinLoader(true);
    updatePin(id, rowData?.uuid, pin).then((result: any) => {
      if (!result?.success) {
        let msg = result?.message;
        Notification(
          "Failed",
          msg?.charAt(0).toUpperCase() + msg.slice(1),
          "danger",
        );
        setResetPinLoader(false);
      } else {
        Notification("Success", "PIN updated successfully", "success");
        setResetPinModal(false);
        setResetPinLoader(false);
        setEditExtensionModal(false);
        setKey((prev: number) => prev + 1);
      }
    });
  };
  return (
    <>
      <Modal
        title={rowData?.extension}
        closeEvent={() => setEditExtensionModal(false)}
      >
        <div className="lg:w-[600px] md:w-[500px] sm:w-[400px] h-[450px]">
          <FadeIn>
            {displayData?.map((node: any, index: number) => (
              <div
                key={node?.value}
                className={`grid grid-cols-2 gap-4 p-2.5 border-b border-b-[#d1d1d1] hover:bg-[#FEF4E9] ${
                  index % 2 === 0 ? "bg-[#F5F6FF]" : ""
                }`}
              >
                <div className="text-[#7C7C7C] font-semibold">{node.label}</div>
                <div>{rowData[node.key]}</div>
              </div>
            ))}

            <div className="p-2 mt-2 font-bold">Extension Features</div>
            {toggleOptions?.map((node: any) => {
              return (
                <div className="flex justify-between items-center pt-3 p-2.5 border-b border-b-[#d1d1d1]">
                  <div> {node.label}</div>
                  <ToggleButton
                    click={() => handleChecked(node)}
                    // checked={rowData[node.key]}
                    checked={localRowData[node.key]}
                  />
                </div>
              );
            })}
            <div className=" h-full py-4 pl-3 mt-4 ">
              <div>{`PIN : ${rowData?.pin === "" ? "Not available" : rowData?.pin}`}</div>
              <div
                className="text-[#1256FE] mt-1 cursor-pointer w-fit"
                onClick={handleResetPinClick}
              >
                Reset PIN ?
              </div>
            </div>

            <div className="float-right mt-20  mb-6 ">
              <ThemedButton
                children={"Cancel"}
                theme="secondary"
                click={() => setEditExtensionModal(false)}
              />
              <ThemedButton
                children={"Submit"}
                theme="primary"
                click={() => handleSubmit()}
                loading={buttonLoader}
              />
            </div>
          </FadeIn>
        </div>
      </Modal>

      {resetPinModal && (
        <Modal
          title={"Reset PIN"}
          closeEvent={() => {
            setResetPinModal(false);
          }}
        >
          <div className="mt-2 relative w-[540px]">
            <ComponentMap data={pinData} setData={setPinData} />
          </div>
          <div className=" w-full h-full flex items-baseline justify-end mt-8 -ml-1">
            <ThemedButton
              children={"Cancel"}
              theme="secondary"
              click={() => setResetPinModal(false)}
            />
            <ThemedButton
              children={"Reset PIN"}
              icon="custom"
              theme="primary"
              valiData={pinData}
              change={setPinData}
              click={handleUpdatePin}
              loading={resetPinLoader}
            />
          </div>
        </Modal>
      )}
    </>
  );
}

export default EditTenantExtensionModal;
